import {useSelector} from 'react-redux';
import Selector from '../../../selectors/pages/main/freeplays';
import {useNavigate} from 'react-router-dom';

export default () => {
    const {wallet} = useSelector(Selector),
          navigate = useNavigate();

    if(!["1168949833", "5047883422"].includes(wallet.id))
        return <></>;

    return (
        <div className="freeplay-status" onClick={e => {
            navigate('/cashback');
        }}>
            <div className="top">
                <div className="left">
                    <div className="icon">
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M16.6417 8.33325H3.30835V14.9999C3.30835 17.4999 4.14168 18.3333 6.64168 18.3333H13.3083C15.8083 18.3333 16.6417 17.4999 16.6417 14.9999V8.33325Z" fill="none" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M17.9166 5.83341V6.66675C17.9166 7.58341 17.4749 8.33341 16.2499 8.33341H3.74992C2.47492 8.33341 2.08325 7.58341 2.08325 6.66675V5.83341C2.08325 4.91675 2.47492 4.16675 3.74992 4.16675H16.2499C17.4749 4.16675 17.9166 4.91675 17.9166 5.83341Z" fill="none" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M9.69998 4.16662H5.09998C4.81665 3.85828 4.82498 3.38328 5.12498 3.08328L6.30832 1.89995C6.61665 1.59162 7.12498 1.59162 7.43332 1.89995L9.69998 4.16662Z" fill="none" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M14.8917 4.16662H10.2917L12.5584 1.89995C12.8667 1.59162 13.3751 1.59162 13.6834 1.89995L14.8667 3.08328C15.1667 3.38328 15.1751 3.85828 14.8917 4.16662Z" fill="none" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M7.44995 8.33325V12.6166C7.44995 13.2833 8.18328 13.6749 8.74162 13.3166L9.52495 12.7999C9.80829 12.6166 10.1666 12.6166 10.4416 12.7999L11.1833 13.2999C11.7333 13.6666 12.475 13.2749 12.475 12.6083V8.33325H7.44995Z" fill="none" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </div>

                    Freeplays not available
                </div>
                <div className="right">
                    Why?
                </div>
            </div>
        </div>
    )
}